import { render, staticRenderFns } from "./SendMessagesTab.vue?vue&type=template&id=7c560c00&scoped=true&lang=pug"
import script from "./SendMessagesTab.vue?vue&type=script&lang=ts"
export * from "./SendMessagesTab.vue?vue&type=script&lang=ts"
import style0 from "./SendMessagesTab.vue?vue&type=style&index=0&id=7c560c00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c560c00",
  null
  
)

export default component.exports